import { Component, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { first, takeUntil, takeLast } from 'rxjs/operators';
import { Subject } from 'rxjs';
@Component({
    selector: 'app-profile-management',
    templateUrl: 'user-profile.component.html',
    styleUrls: ['./user-profile.component.scss']

})
export class UserProfileComponent implements OnDestroy {
    routeWithoutId: boolean;
    ngOnDestroy() {
        this.stopper$.next();
        this.stopper$.complete();
    }
    userIdParam: string;
    stopper$: Subject<any> = new Subject();
    constructor(public route: ActivatedRoute, public router: Router, public location: Location) {
        this.route.firstChild.paramMap.subscribe(param => {
            this.userIdParam = param['params'].id
            if(this.userIdParam === undefined) {
                this.routeWithoutId =true;
            }
            else {
                this.routeWithoutId =false
            }
        })
    }
    ngOnInit() {

        this.router.events.pipe(takeUntil(this.stopper$)).subscribe((event) => {

            if (event instanceof NavigationEnd) {

                let url = this.router.url;
                let endPoint =url.split('/').pop();
               this.routeWithoutId = ( ['change-password','edit'].includes(endPoint)) ? true: false
               
            }
        })

    }

    // goToTab(path: string) {


    //     if (this.userIdParam) {
    //         this.router.navigate(['/home/profile/' + path, this.userIdParam])
    //     }
    //     else {
    //         this.router.navigate(['/home/profile/' + path])
    //     }
    // }

}